/**
 * @generated SignedSource<<4169677db708352c73c5b9bbf1a1d7ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateThreadReactionInput = {
  reaction: string;
  referenceId: string;
};
export type AnnouncementReactions_chat_createReaction_Mutation$variables = {
  input: CreateThreadReactionInput;
};
export type AnnouncementReactions_chat_createReaction_Mutation$data = {
  readonly createThreadReaction: {
    readonly conversation: {
      readonly id: string;
    };
    readonly deletedAt: ISO8601DateTimeString | null;
    readonly id: string;
    readonly senderId: string | null;
    readonly text: UnknownJSON;
  };
};
export type AnnouncementReactions_chat_createReaction_Mutation = {
  response: AnnouncementReactions_chat_createReaction_Mutation$data;
  variables: AnnouncementReactions_chat_createReaction_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Message",
    "kind": "LinkedField",
    "name": "createThreadReaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementReactions_chat_createReaction_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementReactions_chat_createReaction_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c0691d05df09015343a34e14a4ba2cdb",
    "id": null,
    "metadata": {},
    "name": "AnnouncementReactions_chat_createReaction_Mutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementReactions_chat_createReaction_Mutation(\n  $input: CreateThreadReactionInput!\n) {\n  createThreadReaction(input: $input) {\n    id\n    text\n    senderId\n    deletedAt\n    conversation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "721b3a7fe947607a6a80b4b3e0514f41";

export default node;
